import 'waypoints/lib/jquery.waypoints.min'
import 'waypoints/lib/shortcuts/sticky.min'

jQuery(document).ready(function($) {
  const headerSticky = new Waypoint.Sticky({
    element: $('.header-corporate .mainmenu-container')[0],  
    offset: '-90px',
  }); 
});